<template>
  <div>
    <AlertDismiss ref="alertDismiss" class="mx-2"></AlertDismiss>

    <b-table
      ref="table"
      :busy="isBusy"
      :fields="fields"
      :items="items"
      no-border-collapse
      responsive
      show-empty
      sticky-header="60vh"
    >
      <template #empty>
        <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
          No hay plantillas que coincidan con los criterios de búsqueda
        </b-card>
        <b-card v-else class="text-center my-2 fs-5">
          Aún no se ha agregado ninguna plantilla
        </b-card>
      </template>

      <!--icono de carque de tabla-->
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Cargando datos de tabla...</strong>
        </div>
      </template>

      <template #cell(details)="row">
        <b-button
          class="mr-2"
          size="sm"
          variant="outline-secondary"
          @click="row.toggleDetails"
        >
          <div v-if="row.detailsShowing">
            <span class="d-none d-md-inline me-2">Ocultar</span>
            <b-icon font-scale="1" icon="eye-slash-fill"></b-icon>
          </div>
          <div v-else>
            <span class="d-none d-md-inline me-2">Ver</span>
            <b-icon font-scale="1" icon="eye-fill"></b-icon>
          </div>
        </b-button>
      </template>

      <template #row-details="row">
        <b-card>
          <div>
            <b>Preguntas de la plantilla</b>
            <ol class="m-0">
              <li v-for="question in row.item.questions" :key="question.id">
                <span>{{ question.name }}</span>
                <span v-if="question.fieldNameCargo" class="ms-2">
                  <b-badge
                    variant="light"
                    class="text-muted border"
                    style="font-size: 0.7em"
                  >
                    <b-icon icon="person-fill" class="me-1"></b-icon
                    >{{ question.fieldNameCargo }}
                  </b-badge>
                </span>
                <span v-if="question.fieldNameDate" class="ms-1">
                  <b-badge
                    variant="light"
                    class="text-muted border"
                    style="font-size: 0.7em"
                  >
                    <b-icon icon="calendar-date" class="me-1"></b-icon
                    >{{ question.fieldNameDate }}
                  </b-badge>
                </span>
                <ol class="m-0 ps-4">
                  <li
                    v-for="subquestion in question.childrenQuestionDTO"
                    :key="subquestion.id"
                  >
                    <span>{{ subquestion.name }}</span>
                    <span v-if="subquestion.fieldNameCargo" class="ms-2">
                      <b-badge
                        variant="light"
                        class="text-muted border"
                        style="font-size: 0.7em"
                      >
                        <b-icon icon="person-fill" class="me-1"></b-icon
                        >{{ subquestion.fieldNameCargo }}
                      </b-badge>
                    </span>
                    <span v-if="subquestion.fieldNameDate" class="ms-1">
                      <b-badge
                        variant="light"
                        class="text-muted border"
                        style="font-size: 0.7em"
                      >
                        <b-icon icon="calendar-date" class="me-1"></b-icon
                        >{{ subquestion.fieldNameDate }}
                      </b-badge>
                    </span>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </b-card>
      </template>

      <template #cell(document)="row">
        <button
          v-b-tooltip.hover.right
          class="btn btn-light btn-sm"
          title="Ver documento"
          @click="openDocument(row)"
        >
          <b-icon font-scale="1" icon="file-earmark" variant="primary"></b-icon>
        </button>
      </template>
    </b-table>

    <BaseModal v-model="modalShowDocument" size="xl">
      <DocumentPdf :pdfUrl="documentUrl"></DocumentPdf>
    </BaseModal>
  </div>
</template>
<script>
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import { EventNames } from "@/plugins/enums/index.js";
import { mapActions } from "vuex";
import { formatDateTime } from "@/plugins/complianceScripts/index.js";
import BaseModal from "@/components/shared/Base-modal.vue";
import DocumentPdf from "@/components/shared/Document-pdf.vue";

export default {
  name: "StatementTemplateList",

  components: {
    AlertDismiss,
    BaseModal,
    DocumentPdf,
  },

  data() {
    return {
      isBusy: false,
      modalShowDocument: false,

      fields: [
        { key: "name", label: "Nombre" },
        {
          key: "creationDate",
          label: "Fecha de creación",
          formatter: formatDateTime,
        },
        { key: "details", label: "Detalle", thClass: "col-2" },
        { key: "document", label: "Opciones", thClass: "col-2" },
      ],

      selected: [],

      items: [],

      documentUrl: "",
    };
  },

  async mounted() {
    this.getAll();

    this.$eventBus.$on(EventNames.CreatedStatementTemplate, async () => {
      await this.getAll();
    });
  },

  methods: {
    ...mapActions(["getAllPepStatementTemplates", "getPepDocumentUrl"]),

    async getAll() {
      this.isBusy = true;
      const result = await this.getAllPepStatementTemplates();

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        this.isBusy = false;
        return;
      }

      this.items = result.data;
      this.isBusy = false;
    },

    async openDocument(row) {
      const route = row.item.document.route;
      this.modalShowDocument = true;
      const result = await this.getPepDocumentUrl({ route });
      if (result.isError) {
        this.modalShowDocument = false;
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }
      this.documentUrl = result.data;
    },
  },
};
</script>
<style>
.abbreviation {
  display: inline;
  font-weight: bold;
  font-family: monospace;
}
</style>
